import { render, staticRenderFns } from "./MicrolearningChapterCard.vue?vue&type=template&id=a31495f6&scoped=true"
import script from "./MicrolearningChapterCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningChapterCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningChapterCard.vue?vue&type=style&index=0&id=a31495f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31495f6",
  null
  
)

export default component.exports